import React from 'react';
import {
  ArrowsRightLeftIcon,
  CalendarDaysIcon,
  ChartBarIcon,
  ChatBubbleLeftRightIcon,
  ClipboardDocumentCheckIcon,
  ClipboardDocumentListIcon,
  Cog6ToothIcon,
  ClockIcon,
  HeartIcon,
  HomeIcon,
  PlayCircleIcon,
  QuestionMarkCircleIcon,
  QueueListIcon,
  RectangleStackIcon,
  TrophyIcon,
  UserCircleIcon,
  UserGroupIcon,
  UserPlusIcon,
  UsersIcon,
} from '@heroicons/react/24/outline';

export type NavigationIcon = React.ComponentType<React.SVGProps<SVGSVGElement>>;

const NAVIGATION_ICONS: Record<string, NavigationIcon> = {
  home: HomeIcon,
  'player-home': HomeIcon,
  profile: UserCircleIcon,
  calendar: CalendarDaysIcon,
  'player-calendar': CalendarDaysIcon,
  matches: PlayCircleIcon,
  season: RectangleStackIcon,
  'external-matches': TrophyIcon,
  squad: UserGroupIcon,
  team: ClipboardDocumentCheckIcon,
  'external-players': UserPlusIcon,
  comparison: ArrowsRightLeftIcon,
  analysis: ChartBarIcon,
  'chat-history': ChatBubbleLeftRightIcon,
  reports: ClipboardDocumentListIcon,
  scheduling: Cog6ToothIcon,
  queue: QueueListIcon,
  users: UsersIcon,
  'audit-log': ClockIcon,
  'player-medical': HeartIcon,
};

export function getNavigationIcon(itemId: string): NavigationIcon {
  return NAVIGATION_ICONS[itemId] ?? QuestionMarkCircleIcon;
}
